import styled from "styled-components"
import {Label} from "@irati/ui/src/Typography"

export default styled.div`
  display: flex;
  justify-content: space-between;
  ${Label} {
    color: ${({theme}) => theme.colors.greys.medium};
  }
`
